<div
  class="overlay"
  [@blurFadeInOut]="isClosing ? 'fadeOut' : 'fadeIn'"
  (@blurFadeInOut.done)="onAnimationDone()"
></div>
<div
  class="container"
  [@fadeInOut]="isClosing ? 'fadeOut' : 'fadeIn'"
  (@fadeInOut.done)="onAnimationDone()"
  appClickedOutside
  (clickedOutside)="closeModal()"
>
  <button class="close-btn" (click)="closeModal()">
    <qai-icon kind="x-close" size="24px" />
  </button>
  <div class="help-icon-wrapper">
    <qai-icon [kind]="'help-circle'" [size]="'24px'"></qai-icon>
  </div>
  <h3 class="title">{{'general.NEED_HELP_QUESTION' | transloco}}</h3>
  <div class="body">
    {{'general.HELP_SEARCH_OUR' | transloco}}
    <a [href]="knowledgeBaseUrl" target="_blank" rel="noopener noreferrer" class="help-link" (click)="onKnowledgeBaseClick()">
      {{'general.KNOWLEDGE_BASE' | transloco}}
    </a>
    {{'general.HELP_OR_REACH_OUT_TO' | transloco}}
    <a [href]="helpEmailUrl" class="help-link">{{'general.HELP_EMAIL' | transloco}}</a>
    {{'general.HELP_WITH_QUESTIONS' | transloco}}
  </div>
</div>
